/**
 * Constantes de layout do Modern Layout (header, sidebar).
 * Fonte única de valores numéricos de layout do frontend.
 *
 * Regra obrigatória: .agent/rules/rule-15-layout-design.md
 * Todos os padrões de layout e design (header, scrollbar, ActionBar, filtros, etc.)
 * são mandatórios; não alterar sem alinhar com a regra.
 */

/** Espaço à esquerda do header (distância do botão de colapsar em relação à sidebar), em px. */
export const HEADER_LEFT_PADDING_PX = 15

/** Espaço à direita do header (padding direito), em px. */
export const HEADER_RIGHT_PADDING_PX = 16

/** Altura do Header Fixo (ModernHeader), em px. */
export const HEADER_HEIGHT_PX = 64

/** Altura da ActionBar (Barra de Ações), em px. */
export const ACTION_BAR_HEIGHT_PX = 85

/** Padding Superior do Layout (Header + ActionBar + Espaço Extra), em px. */
// 64 (header) + 85 (actionbar) + 32 (margem extra) = 181
export const MAIN_CONTENT_PADDING_TOP_PX = 181
